import clsx from 'clsx';

function Item({ translateX, label, color }) {
  const labelCls = clsx(
    'align-left whitespace-nowrap overflow-hidden text-ellipsis text-[11px] -translate-x-1/2',
    color && 'rounded text-white p-1',
    color === 'blue' && 'bg-blue-500/70',
    color === 'gray' && 'bg-gray-500/70',
  );
  return (
    <div
      className="absolute top-0 left-0 bottom-0 flex items-center"
      style={{ transform: `translateX(${translateX}px)` }}
    >
      <div></div>
      <div className={labelCls}>{label}</div>
    </div>
  );
}

export default function HeaderRow({ items, additionalItems = [] }) {
  return (
    <div className="h-[16px] relative top-0">
      {items.map((item) => {
        return (
          <Item
            key={item.key}
            label={item.label}
            translateX={item.translateX}
          />
        );
      })}
      {additionalItems.map((item) => {
        return (
          <Item
            key={item.key}
            translateX={item.translateX}
            label={item.label}
            color={item.color || 'blue'}
          />
        );
      })}
    </div>
  );
}
